import { useTheme } from '@emotion/react';
import { Fire, GoldMedalTwo } from '@icon-park/react';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Avatar,
  AvatarBlock,
  type AvatarBlockProps,
  Typography,
} from '@didaskill/ui/design-system';

import messages from './ProfileCard.messages';
import * as styles from './ProfileCard.styles';

export type ProfileCardProps = AvatarBlockProps & {
  nbStreaks: number;
  nbAchievements: number;
};

export const ProfileCardBase = ({
  user,
  title,
  nbStreaks,
  nbAchievements,
  connectionStatus,
  subtitle,
}: ProfileCardProps) => {
  const theme = useTheme();

  return (
    <div css={styles.container}>
      <AvatarBlock
        user={user}
        title={title}
        subtitle={subtitle}
        size={Avatar.SIZES.LARGE}
        connectionStatus={connectionStatus}
      />

      <div css={styles.lineSeparator} />

      <div css={styles.content}>
        <div css={styles.item}>
          <Typography variant={Typography.VARIANTS.BODY_SMALL_REGULAR} css={styles.label}>
            <FormattedMessage {...messages.STREAKS_LABEL} />
          </Typography>

          <div css={styles.statistics}>
            <Fire fill={[theme.colors.secondary[400], theme.colors.warning[300]]} />
            <Typography variant={Typography.VARIANTS.BODY_SMALL_BOLD}>{nbStreaks}</Typography>
          </div>
        </div>

        <div css={styles.verticalSeparator} />

        <div css={styles.item}>
          <Typography variant={Typography.VARIANTS.BODY_SMALL_REGULAR} css={styles.label}>
            <FormattedMessage {...messages.ACHIEVEMENTS_LABEL} />
          </Typography>

          <div css={styles.statistics}>
            <GoldMedalTwo fill={[theme.colors.primary[400], theme.colors.primary[100]]} />
            <Typography variant={Typography.VARIANTS.BODY_SMALL_BOLD}>{nbAchievements}</Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

ProfileCardBase.displayName = 'ProfileCard';

export const ProfileCard = memo(ProfileCardBase);
